import camelcaseKeys from 'camelcase-keys'

export class PageObjectButton {
  constructor (params = {}) {
    const { id, order, title, url, authenticated } = camelcaseKeys(params ? params : {})
    this.id = id
    this.order = order || 0
    this.title = title || null
    this.url = url || null
    this.authenticated = authenticated || false
  }
  serialize (editedFields) {
    const item = JSON.parse(JSON.stringify(this))
    Object.keys(editedFields).forEach(key => {
      item[key] = editedFields[key]
    })
    return {
      id: item.id,
      title: item.title,
      order: item.order,
      authenticated: item.authenticated,
      url: item.url,
    }
  }
}
